import React from 'react';

export default function ProminentSearchButton() {
  return (
    <>
      <button
        type="submit"
        className="rounded-full border-none h-14 w-14 p-4 bg-gray-800 m-2 hidden md:block"
        aria-label="Submit Search"
      >
        <svg
          className="prominent-button fill-current text-white"
          width={24}
          height={24}
          viewBox="0 0 24 24"
        >
          <path
            d="M15.9471365,14.5813852 L15.176316,14.5813852 L14.9031138,14.315539 C16.0739803,12.9370775 16.678928,11.0564621 16.3471825,9.05769289 C15.8885931,6.32046212 13.6249179,4.13461597 10.8928961,3.79984674 C6.76559165,3.28784674 3.29202103,6.79307751 3.79939651,10.9580006 C4.13114202,13.7149237 6.29724505,15.9992314 9.00975244,16.4620006 C10.9904683,16.7967698 12.8540975,16.1863083 14.2201084,15.0047698 L14.4835533,15.2804621 L14.4835533,16.0583083 L18.6303722,20.2429237 C19.0304182,20.646616 19.684152,20.646616 20.0841981,20.2429237 C20.4842442,19.8392314 20.4842442,19.179539 20.0841981,18.7758467 L15.9471365,14.5813852 Z M10.092804,14.5813852 C7.66325596,14.5813852 5.70205457,12.6023083 5.70205457,10.150616 C5.70205457,7.69892366 7.66325596,5.71984674 10.092804,5.71984674 C12.5223519,5.71984674 14.4835533,7.69892366 14.4835533,10.150616 C14.4835533,12.6023083 12.5223519,14.5813852 10.092804,14.5813852 Z"
            id="path-1"
          />
        </svg>
      </button>
      <button
        type="submit"
        className="rounded-full border-none h-6 w-6 my-2 mx-4 md:hidden"
      >
        <svg
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.486 15.4774H17.5981L23.5671 21.471C24.1443 22.0479 24.1443 22.9905 23.5671 23.5674C22.9899 24.1442 22.0467 24.1442 21.4695 23.5674L15.4865 17.5878V16.4763L15.1064 16.0824C13.1355 17.7707 10.4466 18.643 7.58881 18.1647C3.67519 17.5034 0.549915 14.2393 0.0712697 10.2998C-0.660776 4.34837 4.35092 -0.660388 10.3058 0.0712279C14.2476 0.549592 17.5137 3.67303 18.1753 7.58436C18.654 10.4405 17.7811 13.1278 16.0918 15.0975L16.486 15.4774ZM2.82371 9.17665C2.82371 12.6919 5.66136 15.5296 9.17665 15.5296C12.6919 15.5296 15.5296 12.6919 15.5296 9.17665C15.5296 5.66136 12.6919 2.82371 9.17665 2.82371C5.66136 2.82371 2.82371 5.66136 2.82371 9.17665Z"
            fill="#1F2830"
          />
        </svg>
      </button>
    </>
  );
}
